<route-meta>
{
  "transitionName": "fade"
}
</route-meta>

<i18n>
{
  "en": {
    "login": {
      "cta": "Login",
      "forgot": "Forgot password?",
      "messages": {
        "success": "Successfully logged in",
        "fail": "Combination of password and username is incorrect",
        "first": "This looks like you are installing new project, app wil try to create new user for you with specified name and password",
        "network": "Network Error, is your API running?"
      }
    }
  }
}
</i18n>

<template>
  <div class="login">
    <field
      v-model="object['username']"
      :field="{ placeholder: 'Username' }"
    ></field>
    <field
      v-model="object['password']"
      :field="{ type: 'password', placeholder: 'Password' }"
    ></field>
    <div class="row">
      <div class="col">
        <button
          class="btn btn-success"
          @click="login"
        >
          {{ $t('login.cta') }}
        </button>
      </div>
      <div class="col text-right">
        <router-link :to="{ name: 'forgot' }">
          {{ $t('login.forgot') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Field from '@/components/Field';

export default {
  name: 'login',
  components: {
    Field,
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
    }),
  },
  data() {
    return {
      loading: false,
      object: {
        username: null,
        password: null,
      },
    };
  },
  created() {
    this.$store.dispatch('breadcrumbs/reset');
  },
  methods: {
    setLoading() {
      this.loading = !this.loading;
      setTimeout(() => {
        this.loading = !this.loading;
      }, 3000);
    },
    createToken(data, { success, error }) {
      if (data && data.username) {
        this.$store.dispatch('auth/CREATE_TOKEN', {
          payload: data,
          callback: () => {
            if (typeof success === 'function') {
              success(data);
            }
          },
        });
      } else {
        if (typeof error === 'function') {
          error(data);
        }
      }
    },
    validate(callbacks) {
      this.$store.dispatch('auth/login', {
        username: this.object.username,
        password: this.object.password,
        callback: data => {
          if (data && data.username) {
            this.createToken(data, callbacks);
          } else {
            this.tryCreateFirstUser();
          }
        },
      });
    },
    login() {
      this.validate({
        success: () => {
          this.$success(this.$t('login.messages.success'));
          if (this.$route && this.$route.query && this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          }
        },
        error: () => {
          // Login failed
          this.tryCreateFirstUser();
        },
      });
    },
    tryCreateFirstUser() {
      this.$store.dispatch('users/get', {
        callback: data => {
          // If there is no user in database at all, create such user and retry
          if (!data.length) {
            this.$info(this.$t('login.messages.first'));
            this.$store.dispatch('users/add', {
              object: this.object,
              callback: () => {
                this.login();
              },
            });
          } else {
            this.$error(this.$t('login.messages.fail'));
          }
        },
      });
    },
  },
};
</script>
